// /league/schedule/ で使用

import { Swiper, Navigation } from 'swiper/core';
Swiper.use([Navigation]);

export default () => {

  const s = {}
  s.isSpMedia = window.matchMedia('(max-width: 768px)');
  const init = () => {
    s.root = document.getElementById('calendar');
    if (!s.root) {
      return
    }
    console.log('init calendar');

    buildSwiper();
  }

  // カレンダーの月表示切り替えをswiperで構築
  const buildSwiper = () => {
    const container = s.root.querySelector('.le-calendar__container');
    s.prevBtn = s.root.querySelector('.le-calendar__pager-btn._prev');
    s.nextBtn = s.root.querySelector('.le-calendar__pager-btn._next');

    // APIより表示用データを取得するため、APIデータの処理の後に発火させるため関数を登録
    // トリガー発火は先ファイルで行う：/assets/scripts/data/league_calendar.js
    container.build = () => {
      s.yearElement = s.root.querySelector('#cal-year');
      s.yearNumber = Number(s.yearElement.textContent);
      s.monthElement = s.root.querySelector('#cal-month');
      s.monthNumber = Number(s.monthElement.textContent);

      const slides = s.root.querySelectorAll('.le-calendar__slide');
      const initSlideIndex = [].findIndex.call(slides, slide => {
        return Number(slide.dataset.year) == s.yearNumber
          && Number(slide.dataset.month) == s.monthNumber;
      })

      const swiperOption = {
        initialSlide: initSlideIndex,
        navigation: {
          nextEl: s.nextBtn,
          prevEl: s.prevBtn
        },
        autoHeight: true,
        on: {
          slideChangeTransitionStart: (swiper) => {
            const activeIndex = swiper.activeIndex;
            const slide = swiper.slides[activeIndex]
            setCurrentStatus(activeIndex);
            setCurrentYearNum(slide.dataset.year)
            setCurrentMonthNum(slide.dataset.month);
          }
        }
      }

      s.months = document.querySelectorAll('.le-side-month__list-item');
      attachClickNavigationBtnAction();
      attachControleMonthNavigation();

      s.calendar = new Swiper(container, swiperOption);
    }
    container.destroy = () => {
      s.calendar.destroy();
      detachClickNavigationBtnAction();
      detachControleMonthNavigation();
    }
  }


  const attachClickNavigationBtnAction = () => {
    s.prevBtn.addEventListener('click', clickPrevBtn)
    s.nextBtn.addEventListener('click', clickNextBtn)
  }
  const detachClickNavigationBtnAction = () => {
    s.prevBtn.removeEventListener('click', clickPrevBtn)
    s.nextBtn.removeEventListener('click', clickNextBtn)
  }
  const clickPrevBtn = () => {
    const prevMonthNum = --s.monthNumber;
    if (prevMonthNum == 0) {
      s.yearElement.textContent = --s.yearNumber;
      s.monthElement.textContent = 12;
    } else {
      s.monthElement.textContent = prevMonthNum;
    }
    s.monthNumber = Number(s.monthElement.textContent);

    setCurrentStatus(s.calendar.activeIndex);
  }
  const clickNextBtn = () => {
    const nextMonthNum = ++s.monthNumber;
    if (nextMonthNum == 13) {
      s.yearElement.textContent = ++s.yearNumber;
      s.monthElement.textContent = 1;
    } else {
      s.monthElement.textContent = nextMonthNum;
    }
    s.monthNumber = Number(s.monthElement.textContent);

    setCurrentStatus(s.calendar.activeIndex);
  }
  // サイドバーもしくはsp時の月選択による切り替えをswiperに同期
  const attachControleMonthNavigation = () => {
    s.filteringMonths = [].filter.call(s.months, liEle => {
      return !liEle.classList.contains('_disabled')
    })

    s.filteringMonths.forEach((liEle, lIdx) => {
      const monthStr = liEle.dataset.month;
      const link = liEle.querySelector('.le-side-month__link');
      link.addEventListener('click', function clickMonthBtn(e) {
        e.preventDefault();
        clickMonthBtnAction(lIdx, monthStr);
      })
    });
  }
  const detachControleMonthNavigation = () => {
    s.months.forEach((liEle, lIdx) => {
      const monthStr = liEle.dataset.month;
      const link = liEle.querySelector('.le-side-month__link');
      link.removeEventListener('click', function clickMonthBtn(e) {
        e.preventDefault();
        clickMonthBtnAction(lIdx, monthStr);
      });
    });
  }
  const clickMonthBtnAction = (index, monthStr) => {
    s.calendar.slideTo(index);
    setCurrentMonthNum(monthStr);
    setCurrentStatus(index);
    if (s.isSpMedia.matches) {
      window.scrollBy({
        left:0,
        top: s.root.getBoundingClientRect().top,
        behavior: 'smooth'
      })
    }
  }
  const setCurrentYearNum = (yearStr) => {
    s.yearElement.textContent = Number(yearStr);
  }
  const setCurrentMonthNum = (monthStr) => {
    s.monthElement.textContent = Number(monthStr);
    s.monthNumber = Number(monthStr);
  }
  const setCurrentStatus = (index) => {
    resetMonthCurrent();
    s.filteringMonths[index].classList.add('is-current');
  }
  const resetMonthCurrent = () => {
    s.months.forEach(month => month.classList.remove('is-current'))
  }

  init();
}
